import { render, staticRenderFns } from "./TgNewsCardPageItem.vue?vue&type=template&id=4a5953e7&"
import script from "./TgNewsCardPageItem.vue?vue&type=script&lang=js&"
export * from "./TgNewsCardPageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports